import BasicContentFirmFeature from './BasicContentFirmFeature';

export { type BasicContentFirmFeatureProps } from './BasicContentFirmFeature';
export default BasicContentFirmFeature;
